var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_10133",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 10133",
    transform: "translate(-473 -290)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_10053",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 10053",
    transform: "translate(245.489 842.486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_8254",
    "data-name": "\\u30D1\\u30B9 8254",
    d: "M269.4-408.075l-3.433,4.858-3.431-4.861",
    transform: "translate(-28.422 -131.385)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_8255",
    "data-name": "\\u30D1\\u30B9 8255",
    d: "M234.112-539.464l-.437-.615m7.736,0,.96-1.356a6.632,6.632,0,0,0-.56-8.318,6.121,6.121,0,0,0-8.532,0,6.631,6.631,0,0,0-.568,8.31l.965,1.366.437.615,3.431,4.861,3.433-4.858m-1.251-6.082a2.157,2.157,0,0,1-2.238,2.072,2.12,2.12,0,0,1-2.073-2.156c0-.027,0-.054,0-.082a2.156,2.156,0,0,1,2.238-2.072A2.156,2.156,0,0,1,239.725-545.543Zm1.215,6.079.437-.615Z",
    transform: "translate(0 0)",
    fill: "#ccc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddress);
export default __webpack_public_path__ + "static/media/icon_address.d1d6c18dd2fd39a5c35fbf97cc8d3ba7.svg";
export { ForwardRef as ReactComponent };